// FAQ accordion — keeps the native <details> open behaviour and adds
// "click the answer to close" without any animation.
if (!customElements.get("faq-accordion")) {
  customElements.define(
    "faq-accordion",
    class FaqAccordion extends HTMLElement {
      constructor() {
        super();
        this.details = this.querySelector("details");
        this.content = this.querySelector("[data-faq-content]");
        this.onContentClick = this.onContentClick.bind(this);
      }

      connectedCallback() {
        this.content?.addEventListener("click", this.onContentClick);
      }

      disconnectedCallback() {
        this.content?.removeEventListener("click", this.onContentClick);
      }

      onContentClick(event) {
        // Let links inside the answer behave normally.
        if (event.target.closest("a")) return;
        if (this.details?.open) this.details.open = false;
      }
    },
  );
}
